export default __webpack_public_path__ + "static/media/2 (2000).a1157432.jpg";